import {
  AfterViewInit,
  Component,
  EmbeddedViewRef,
  Input,
  TemplateRef,
  ViewChild,
  ViewContainerRef,
  ViewEncapsulation,
} from '@angular/core';
import { EaDisplay } from '@app/components/pr-display';

@Component({
    selector: 'pr-modal',
    templateUrl: './pr-modal.component.html',
    styleUrls: ['./pr-modal.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class PrModalComponent implements AfterViewInit {
  private viewRef: EmbeddedViewRef<{}>;
  @ViewChild('template') public template: TemplateRef<any>;

  holder: any;
  wrapper: any;

  @Input() display: EaDisplay;
  @Input() clazz: string;

  constructor(private viewContainerRef: ViewContainerRef) {}

  ngAfterViewInit(): void {
    this.holder = document.querySelector('#modal-holder');
  }

  open() {
    // render the view
    this.viewRef = this.viewContainerRef.createEmbeddedView(this.template);
    this.viewRef.detectChanges();

    // attach the view to the DOM element that matches our selector
    this.viewRef.rootNodes.forEach(
      rootNode => (this.wrapper = this.holder.appendChild(rootNode)),
    );
    setTimeout(() => this.wrapper.classList.add('open'), 0);
  }

  close() {
    this.wrapper.classList.remove('open');
    setTimeout(() => {
      this.wrapper = null;
      this.holder.innerHTML = '';
    }, 400);
  }

  get isOpen() {
    return this.wrapper && this.wrapper.classList.value.includes('open');
  }
}
